<template>
  <div class="">
    <h4 class="text-left text-h6">
      {{ title }}
    </h4>

    <!-- Required inputs -->
    <v-row class="order-form-container text-left">
      <v-col cols="12" sm="6">
        <span class="font-weight-bold">
          <label for="cfdi-relac">*Orden de compra:</label>
        </span>
        <v-text-field
          v-model="cfdiForm.orderConcept"
          name="order-concept"
          autocomplete="off"
          hide-details
          dense
          solo
          class="card-shadow rounded-lg"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <span class="font-weight-bold">
          <label for="cfdi-relac">*Destino mercancía:</label>
        </span>
        <v-select
          v-model="cfdiForm.shippingAddressId"
          name="ship-address"
          :item-value="addresItemValue"
          :item-text="addressItemText"
          :items="addressListFormated"
          hide-details
          solo
          dense
          class="card-shadow rounded-lg"
          no-data-text="Sin destinos"
        />
      </v-col>
    </v-row>

    <!-- Division between main and secondary inputs -->
    <v-divider class="pb-2" />

    <!-- Optional inputs -->
    <v-row class="order-form-container text-left">
      <v-col cols="12" sm="6" md="3">
        <span class="font-weight-bold">
          <label for="cfdi-relac">CFDI Relacionado: </label>
        </span>
        <v-select
          v-model="cfdiForm.reBill"
          :items="cfdiRelations"
          name="cfdi-relac"
          item-value="id"
          item-text="des"
          hide-details
          solo
          dense
          class="card-shadow rounded-lg"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <span class="text-left font-weight-bold">
          <label for="documents">Documento relacionado:</label>
        </span>
        <v-text-field
          v-model="cfdiForm.documents"
          class="card-shadow rounded-lg"
          name="documents-two"
          hide-details
          dense
          solo
        />
      </v-col>
      <v-col v-if="showCfdiTwo" cols="12" sm="6" md="3">
        <span class="font-weight-bold">
          <label for="cfdi-relac">CFDI Relacionado 2: </label>
        </span>
        <v-select
          v-model="cfdiForm.reBillTwo"
          :items="cfdiRelations"
          name="cfdi-relac-two"
          item-value="id"
          item-text="des"
          hide-details
          solo
          dense
          class="card-shadow rounded-lg"
        />
      </v-col>
      <v-col v-if="showCfdiTwo" cols="12" sm="6" md="3">
        <span class="text-left font-weight-bold">
          <label for="documents">Documento relacionado 2:</label>
        </span>
        <v-text-field
          v-model="cfdiForm.documentsTwo"
          class="card-shadow rounded-lg"
          name="documents"
          hide-details
          dense
          solo
        />
      </v-col>

      <v-col v-if="showCfdiTwo" cols="12" sm="6">
        <span class="text-left font-weight-bold">
          <label for="documents">Texto ventas material:</label>
        </span>
        <v-textarea
          v-model="cfdiForm.materialsText"
          class="card-shadow rounded-lg"
          name="documents"
          rows="2"
          hide-details
          dense
          solo
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  export default {
    name: 'OrderInformationForm',

    props: {
      value: {
        required: true,
      },

      title: {
        type: String,
        default: 'Información del pedido',
      },

      cfdiRelations: {
        type: Array,
        required: true,
      },

      addressList: {
        type: Array,
        default: () => [],
      },

      addresItemValue: {
        type: String,
        default: 'KUNNR',
      },

      addressItemText: {
        type: String,
        default: 'text',
      },

      noFormatItemText: Boolean,
      showCfdiTwo: Boolean,
    },

    computed: {
      cfdiForm: {
        set(newValue) {
          this.$emit('input', this.value, ...newValue);
        },
        get() {
          return this.value;
        },
      },

      addressListFormated() {
        return !this.noFormatItemText
          ? this.addressList.map((d) => ({
              ...d,
              text: `${d.KUNNR} ${d.STRAS} ${d.ORT01} ${d.PSTLZ} `,
            }))
          : this.addressList;
      },
    },
  };
</script>
<style>
  .order-form-container {
    max-width: 1264px;
  }
</style>
